import './Maps.css'

export default function Maps(){
    return(
        <div className="maps">
            <iframe title="mapa de localização" src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14639.883149685835!2d-46.6043605!3d-23.4615182!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94cef67d2a9af6e1%3A0x8d5b6ea3c15c6e21!2sVidra%C3%A7aria%20Oliveira!5e0!3m2!1spt-BR!2sbr!4v1686746900289!5m2!1spt-BR!2sbr"  loading="lazy"></iframe>
        </div>
    )
}